import { TModificationsModalAction, ModificationsModalActionTypes } from './modificationsModalActions';
import { IModificationsModalState } from './modificationsModalContext';

export const modificationsModalReducer = (
	state: IModificationsModalState,
	action: TModificationsModalAction,
): IModificationsModalState => {
	switch (action.type) {
		case ModificationsModalActionTypes.SET_ALL_DATA:
			return {
				...state,
				dishInfo: action.payload.dishInfo,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				fetchedModificationsDishes: action.payload.fetchedModificationsDishes,
				selectedModificationsDishes: action.payload.selectedModificationsDishes,
			};
		case ModificationsModalActionTypes.SET_MODIFICATIONS_DISH_CATEGORY:
			return {
				...state,
				selectedModificationsDishCategory: action.payload.selectedModificationsDishCategory,
				selectedModificationsDishSubCategory: null,
			};
		case ModificationsModalActionTypes.SET_MODIFICATIONS_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedModificationsDishSubCategory: action.payload.selectedModificationsDishSubCategory,
			};
		case ModificationsModalActionTypes.SET_FETCHED_MODIFICATIONS_DISHES:
			return {
				...state,
				fetchedModificationsDishes: action.payload.fetchedModificationsDishes,
			};
		case ModificationsModalActionTypes.SET_MODIFICATIONS_DISHES:
			return {
				...state,
				selectedModificationsDishes: action.payload.selectedModificationsDishes,
			};
		default:
			return state;
	}
};
